import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=2c2f6f2f"
import script from "./MyPagination.vue?vue&type=script&lang=js"
export * from "./MyPagination.vue?vue&type=script&lang=js"
import style0 from "./MyPagination.vue?vue&type=style&index=0&id=2c2f6f2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports